import { Component, OnInit } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import { AutorizarNovoDispositivoService } from './autorizar-novo-dispositivo.service';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-autorizar-novo-dispositivo',
  templateUrl: './autorizar-novo-dispositivo.component.html',
  styleUrls: ['./autorizar-novo-dispositivo.component.scss']
})
export class AutorizarNovoDispositivoComponent implements OnInit {

  public formAtualizacaoDevice = null;
  public cnpjCpf = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private service: AutorizarNovoDispositivoService,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
  ) {


  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom)

    this.formAtualizacaoDevice = this.formBuilder.group({
      cnpjCpf: [null],
      imei_ativo: [null],
      modelo_ativo: [null],
      device_ativo: [null],
      versao_ativo: [null],
      imei_ultimo: [null],
      modelo_ultimo: [null],
      device_ultimo: [null],
      versao_ultimo: [null],

    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  private normalizarCnpjCpfParaBackend(value: any): string | null {
    if (value == null) return null;
    const valor = String(value).toUpperCase();
    const tipo = DocumentoHelper.detectarTipoDocumento(valor);
    return DocumentoHelper.normalizarParaEnvio(valor, tipo);
  }

  buscaDisposistivo(data){

    const loginNormalizado = this.normalizarCnpjCpfParaBackend(data);

    let register = {

      login: loginNormalizado,

    }

    if(loginNormalizado === null){
      this.notificationService.error("Campo CPF ou CNPJ é obrigatório !!!");

    }else{

      this.spinnerService.show();

      this.service.returnMobileAccess(register, (response => {

        if (response.registroAtual) {
          this.formAtualizacaoDevice.controls['imei_ativo'].setValue(response.registroAtual.imei);
          this.formAtualizacaoDevice.controls['modelo_ativo'].setValue(response.registroAtual.modeloDispositivo);
          this.formAtualizacaoDevice.controls['device_ativo'].setValue(response.registroAtual.acessoId);
          this.formAtualizacaoDevice.controls['versao_ativo'].setValue(response.registroAtual.versaoAplicativo);
        }

        if (response.ultimoRegistro) {
          this.formAtualizacaoDevice.controls['imei_ultimo'].setValue(response.ultimoRegistro.imei);
          this.formAtualizacaoDevice.controls['modelo_ultimo'].setValue(response.ultimoRegistro.modeloDispositivo);
          this.formAtualizacaoDevice.controls['device_ultimo'].setValue(response.ultimoRegistro.acessoId);
          this.formAtualizacaoDevice.controls['versao_ultimo'].setValue(response.ultimoRegistro.versaoAplicativo);
        }

        this.spinnerService.hide();

      }), error => {

        this.spinnerService.hide();
        this.notificationService.error(error.message);

      });

    }

  }

  substituiDevice(data){

    const loginNormalizado = this.normalizarCnpjCpfParaBackend(data);

    let params = new HttpParams();

    params = params.append('login', loginNormalizado)

    if(loginNormalizado === null){
      this.notificationService.error("Campo CPF ou CNPJ é obrigatório !!!");

    }else{

      this.spinnerService.show();

      this.service.updateMobileAccess(params, (response => {

        this.spinnerService.hide();
        this.formAtualizacaoDevice.controls['cnpjCpf'].setValue(null);
        this.formAtualizacaoDevice.controls['imei_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['modelo_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['device_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['versao_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['imei_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['modelo_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['device_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['versao_ultimo'].setValue(null);
        this.notificationService.success(response.message);

      }), error => {

        this.spinnerService.hide();
        this.formAtualizacaoDevice.controls['cnpjCpf'].setValue(null);
        this.formAtualizacaoDevice.controls['imei_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['modelo_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['device_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['versao_ativo'].setValue(null);
        this.formAtualizacaoDevice.controls['imei_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['modelo_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['device_ultimo'].setValue(null);
        this.formAtualizacaoDevice.controls['versao_ultimo'].setValue(null);
        this.notificationService.error(error.message);

      });

    }
  }


  previousPage() {

    this.location.back();

  }

  gotoVoltar() {

    this.location.back();

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
